import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from '../../features/establishment-main/components/products/interfaces/products.interface';
import { ProductData } from '../../features/establishment-main/components/list-products/interfaces/list-products-new.interface';

@Injectable({
  providedIn: 'root'
})
export class ProductModalService {
  private showModalSubject = new BehaviorSubject<boolean>(false);
  private productSubject = new BehaviorSubject<Product |ProductData | null>(null);

  public showModal$: Observable<boolean> = this.showModalSubject.asObservable();
  public product$: Observable<Product | null | ProductData> = this.productSubject.asObservable();

  constructor() {}

  /**
   * Abre el modal con el producto especificado
   * @param product El producto a mostrar en el modal
   */
  openModal(product: Product | ProductData): void {
    this.productSubject.next(product);
    this.showModalSubject.next(true);
  }

  /**
   * Cierra el modal
   */
  closeModal(): void {
    this.showModalSubject.next(false);
    // Limpiamos el producto después de un breve retraso para permitir la animación de cierre
    setTimeout(() => {
      this.productSubject.next(null);
    }, 300);
  }
}
